export const LOG_TYPES = {
  EMAIL: 'email',
  SMS: 'sms',
  EBOKS: 'EBOKS',
}
